module.exports = __webpack_public_path__ + "static/kran01_450-c5dc44cb118fd106a03cafac741259a9.jpg";